import React from "react";

/**
 * A reusable table row component.
 * Supports object-based fields with alignment and auto-checkbox for booleans.
 *
 * @component
 * @param {Object} item - Row data object.
 * @param {number} index - Row index.
 * @param {Array} fields - Field names or objects { field, align }.
 * @param {Array} columns - Matching column definitions.
 * @param {Function} [renderActions] - Optional custom action buttons renderer.
 */
const RuTableRow = ({
  item,
  index,
  fields = [],
  columns = [],
  renderActions,
}) => {
  
  return (
    <tr>
      <td className="text-center">{index + 1}</td>

      {fields.map((fieldDef, i) => {
        // Field definition handling
        const field = typeof fieldDef === "string" ? fieldDef : fieldDef.field;
        console.log(field,'field')
        const align =
          typeof fieldDef === "object" && fieldDef.align
            ? fieldDef.align
            : "center";

        // Extract column alignment (if defined)
        const col = columns[i + 1];
        const alignClass =
          typeof col === "object" && col.align && !fieldDef.align
            ? `text-${col.align}`
            : `text-${align}`;

        // Resolve nested field values
        const value = field.includes(".")
          ? field.split(".").reduce((obj, key) => obj?.[key], item)
          : item[field];

        let displayValue;

        console.log(value)
        if (typeof value === "boolean") {
          displayValue = (
            <input
              type="checkbox"
              checked={value}
              readOnly
              className="form-check-input"
              style={{ cursor: "default" }}
            />
          );
        } else if (value === null || value === undefined || value === "") {
          displayValue = "-";
        } else {
          displayValue = value;
        }

        return (
          <td key={i} className={alignClass}>
            {displayValue}
          </td>
        );
      })}

      {renderActions && (
        <td
          className={
            typeof columns[columns.length - 1] === "object" &&
            columns[columns.length - 1].align
              ? `text-${columns[columns.length - 1].align}`
              : "text-center"
          }
        >
          {renderActions(item, index)}
        </td>
      )}
    </tr>
  );
};

export default RuTableRow;
